<template>
  <div>
    <div class="container-fluid">
      <div class="row row-eq-height">
        <div class="col-sm-6 grey-grad-bg"><br>
          <div class="row">
            <form @submit.prevent="submit" class="col-md-6 col-md-offset-3 text-center pad-top">
              <h1 class="text-uppercase">Returning User</h1>
              <div class="important-notification col-md-12 text-center" v-if="programDisabled">
                <p>This program has been disabled. If you have any questions, contact <a href="mailto:rewards@mercuryfs.com">rewards@mercuryfs.com</a></p>
              </div>
              <input
                id="userName"
                type="username"
                class="form-control client-form-control input-lg"
                :disabled="programDisabled"
                placeholder="Username"
                v-model.trim="userFields.username"
              >
              <input
                id="userPass"
                type="password"
                class="form-control client-form-control input-lg"
                :disabled="programDisabled"
                placeholder="Password"
                v-model.trim="userFields.password"
              >
              <div class="errors" v-if="errors.length > 0">
                <span v-for="(error, index) in errors" :key="index">{{error}}</span>
                <div class="clearfix"></div>
                <br>
              </div>
              <button
                type="submit"
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
                :class="{ disabled: programDisabled }"
                @click.prevent.stop="submit"
              >
                Log In
              </button>
              <a
                href="#"
                @click.prevent=""
                class="small"
                :disabled="programDisabled">
                I forgot my login info
              </a>
              <br>
              <br>
              <br>
            </form>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <div class="col-md-6 col-md-offset-3 text-center pad-top">
              <h1>New User?</h1>
              <p>If you don't have a user login, then register by clicking the button below.</p>
              <a
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
                @click.prevent="register"
                :disabled="programDisabled"
                >
                register now
              </a>
              <!-- <router-link
                to="register"
                class="btn client-btn-primary btn-lg btn-block text-uppercase"
                :disabled="programDisabled"
                type="button">register now</router-link> -->
            </div>
            <br>
            <br>
            <br>
          </div>
        </div>
      </div>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'ClientLogin',
  mounted () {
    this.$store.dispatch('setSlug')
    this.getLoyaltyProgramBySlug(this.slug)
      .then(result => {
        if (!result.data.program) {
          this.$router.push({ name: 'ClientProgramNotFound' })
        }
      })
  },
  data () {
    return {
      userFields: {
        isAdmin: true
      },
      errors: [],
      slug: this.$route.params.slug
    }
  },
  computed: {
    ...mapState('loyaltyProgram', {
      programDisabled: state => state.program.disabled
    })
  },
  methods: {
    ...mapActions('auth', [
      'login'
    ]),
    ...mapActions('loyaltyProgram', [
      'getLoyaltyProgramBySlug'
    ]),
    register () {
      if (this.programDisabled) return
      this.$router.push({ name: 'ClientRegister' })
    },
    submit () {
      if (this.programDisabled) return
      this.login(this.userFields)
        .then(() => this.$router.push({ name: 'ClientDashboard' }))
        .catch(err => {
          console.log(err)
          this.errors = [err.response.data.msg]
        })
    }
  }
}
</script>

<style scoped>
.important-notification {
  border: 2px solid #af0000;
  border-radius: 5px;
  background: #ffdddd;
  padding: 10px 5px;
  margin-bottom: 5px;
  color: #af0000;
}

.important-notification a {
  color: #337ab7;
}

</style>
